import { jsxs, jsx } from 'react/jsx-runtime';
import { FeatureURI } from '@sbt-web/network/types';
import { ItemPrice, Icon, IconSize } from '@sbt-web/ui';
import { isShippable } from '@sbt-web/utils';
import { ProSeals } from '../ProSeals/index.js';
import styles from './index.module.css.js';

const PriceSection = ({ ad, priceClassName = '', enableProBadge, }) => {
    const price = ad.features[FeatureURI.Price]?.values[0]?.key;
    const isShippableAd = isShippable(ad);
    if (!price && !isShippableAd)
        return;
    const adType = ad.type.key;
    return (jsxs("section", { className: styles.priceSection, children: [price && (jsx(ItemPrice, { adType: adType, price: Number(price), classes: [styles.price, priceClassName] })), isShippableAd && (jsxs("div", { className: styles.icons, children: [jsx(Icon, { name: "shipping_promo", classes: [styles.shippingIcon], iconSize: IconSize.SM, accessibleTitle: "Spedizione disponibile" }), enableProBadge && jsx(ProSeals, { item: ad, iconOnly: true })] }))] }));
};

export { PriceSection };
//# sourceMappingURL=index.js.map
